// src/components/Experience.js

import React, { useState } from "react";
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        textAlign: 'left',
    },
};

Modal.setAppElement('#root');

function Experience() {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [highlights, setHighlights] = useState([]);

    const openExperience = (highlights) => {
        setHighlights(highlights);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    }

    const experiences = [
        {
            role: "Backend Engineer",
            company: "Uphold",
            duration: "Set 2024 - Now",
            description: "Backend Engineer in the wallet team, currently leading the team as the main mentor for two junior engineers.",
            website: "https://www.uphold.com",
            highlights: [
                {label: "I lead the team day to day: running code reviews, pairing sessions and architecture discussions with two junior engineers."},
                {label: "I am working on the wallet team, creating new features and maintaining the existing ones."},
                {label: "I improved the performance of the wallet API, focusing on the JS native methods to reduce CPU usage."},
            ],
        },
        {
            role: "Integrations Engineer",
            company: "Issuu",
            duration: "Mar 2024 - Set 2024 (Layoff)",
            description: "I started a new journey in other continent as a Fullstack Engineer in the integration team of the company. I was responsible for implementing the integrations with big partners (Hubspot, Adobe, Canva, etc)",
            website: "https://www.issuu.com",
            highlights: [
                {label: "I was the main responsible for the integration with Hubspot, which was a very challenging and nice integration. You can check how it live in the Hubspot Marketplace.", link: "https://ecosystem.hubspot.com/marketplace/apps/issuu"},
                {label: "I created a SDK for the API that is used by customers and also the integrations team. You can check the SDK public in NPM.", link: "https://www.npmjs.com/package/@issuu/issuu-api-sdk"},
                {label: "I created the new version of the Issuu Wordpress Plugin using the new API V2. You can check the plugin in the Github and inside Wordpress.", link: "https://github.com/issuu/issuu-panel"},
                {label: "I created the new version of the Issuu API Documentation using the new API V2. You can check the documentation in the link.", link: "https://developers.issuu.com"},
            ],
        },
        {
            role: "Tech Lead",
            company: "Carga Online",
            duration: "Aug 2021 - Mar 2024",
            description:
                "As co-founder and Tech Lead, I drove innovation, developed practical solutions, led projects and managed the tech team.",
            website: "https://cargaonline.com.br",
            highlights: [
                {label: "I was co-founder of the company and responsible for all the technology used and created.",},
                {label: "I created a white label automation engine that made possible to create one app white label for each client in less than 1 hour. All the apps are public in the Carga Online developer account on the Stores", link: "https://play.google.com/store/apps/dev?id=5853878619477350458&hl=pt_PT&gl=US"},
                {label: "I hired and managed a team of 5 developers and 1 designer for three years."},
                {label: "I created some integrations with key partners, including one payment gateway, WhatsApp API, GPT API, SMS and Email API, and others."},
            ],
        },
        {
            role: "Tech Lead",
            company: "Fleeting Mobilidade",
            duration: "Jul 2019 - Aug 2021",
            description:
                "As co-founder and Tech Lead, I assumed the role of creating tech solutions, organizing the tech infrastructure, project management, and building a developer team from the ground up.",
            website: "https://www.fleeting.com.br",
            highlights: [
                {label: "I was co-founder of the company and responsible for all the technology used and created.",},
                {label: "I hired and managed a team of 3 developers and 1 designer for two years."},
            ],
        },
        {
            role: "Project Manager & Software Engineer",
            company: "Autonomus",
            duration: "Jul 2017 - Jul 2019",
            description:
                "I launched my career as an entrepreneur, handling small to medium-sized projects. This journey honed my abilities in project structuring, maintenance, solution development, architecture, and customer interaction.",
        },
    ];

    return (
        <section id="experience">
            <h2>Experience</h2>
            <div className="timeline">
            {experiences.map((exp, index) => (
                <article className="experience-item" key={index}>
                    <div className="experience-header">
                        <h3>
                            {exp.role} at <a href={exp.website} target="_blank" rel="noreferrer">
                                {exp.company}
                            </a>
                        </h3>
                        {exp.highlights && (
                            <button
                                type="button"
                                className="highlights-toggle"
                                aria-label={`Highlights for ${exp.company}`}
                                onClick={() => openExperience(exp.highlights)}
                            >
                                +
                            </button>
                        )}
                    </div>
                    <p className="experience-duration">{exp.duration}</p>
                    <p>{exp.description}</p>
                </article>
            ))}
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Experience Highlights"
            >
                <h2>
                    Experience Highlights
                </h2>
                <ul className="highlights-list">
                    {highlights.map((highlight, index) => (
                        <li key={index} style={{
                            backgroundColor: 'transparent',
                            textAlign: 'left',
                        }}>
                            - {highlight.label}&nbsp;
                            {highlight.link && <a href={highlight.link} target="_blank" rel="noreferrer">
                                {highlight.link} (link)
                            </a>}
                        </li>
                    ))}
                </ul>
                <button onClick={closeModal}>Close</button>
            </Modal>
        </section>
    );
}

export default Experience;
